import React, { useState, useEffect } from "react";
import { useTablesDataDispatch, useTablesDataState } from "./TablesDataProvider";
import MenuNewTableSize from "./MenuNewTableSize";
import { ReactComponent as InsertBottom } from "./assets/insert-bottom.svg";
import { ReactComponent as InsertAbove } from "./assets/insert-top.svg";
import { ReactComponent as InsertLeft } from "./assets/insert-left.svg";
import { ReactComponent as InsertRight } from "./assets/insert-right.svg";
import { ObjectActionsType, useObjectsDispatch } from "../../contexts/ObjectsProvider";

type InsertRowMenu = {
  isMenuOpen: boolean;
  setIsMenuOpen(boolean: boolean): void;
};

function InsertRowMenu(props: InsertRowMenu) {
  const TablesDispatch = useTablesDataDispatch();
  const TablesState = useTablesDataDispatch();
  const objectsDispatch = useObjectsDispatch();
  const objectsState = useObjectsDispatch();

  useEffect(() => {
    function clickOutsideMenu(e: MouseEvent) {
      props.setIsMenuOpen(false);
      document.removeEventListener("click", clickOutsideMenu);
    }
    if (props.isMenuOpen) {
      document.addEventListener("click", clickOutsideMenu);
    }
  }, [props.isMenuOpen]);

  return props.isMenuOpen ? (
    // <div className="table-inset-menu">
    <div className="table-inset-menu-body">
      <div
        onClick={() => {
          objectsDispatch({
            type: ObjectActionsType.UPDATE_TABLE,
            payload: { type: "insertRow", value: "above" },
          });
        }}
      >
        <InsertLeft></InsertLeft> Insert Above
      </div>
      <div
        onClick={() => {
          // props.setIsMenuOpen(false);
          // TablesDispatch({ action: "insertRow", payload: ["below"] });
          objectsDispatch({
            type: ObjectActionsType.UPDATE_TABLE,
            payload: { type: "insertRow", value: "below" },
          });
        }}
      >
        <InsertRight></InsertRight> Insert Below
      </div>
    </div>
  ) : // </div>
  null;
}

export default InsertRowMenu;
